import { Text, Flex, Box, Center } from "@chakra-ui/react";

export default function DashboardCard({ label, icon }) {
  return (
    <Flex p="10px" shadow="md" bg="white" rounded="8px">
      <Box flex="1">
        <Text color="primary.500">{label}</Text>
        <Text flex="1" fontSize="32px" as="strong" color="secondary">
          23
        </Text>
      </Box>
      <Center w="80px" h="80px" rounded="12px" bg="primary.500">
        {icon}
      </Center>
    </Flex>
  );
}
